/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Form,
  Input,
  Row,
  Col,
  Button,
  InputNumber,
  InputNumberProps,
  message,
} from 'antd';
import { Formik, FormikHelpers } from 'formik';
import React, { memo, useCallback, useState } from 'react';
import styled from 'styled-components';
import { Dictionaries } from '../../interfaces';
import { BrandApi, GeneralApi, ModelApi, OptionApi, UserApi, ValuationApi } from '../../apis';
import * as Yup from 'yup';
import { QuerySearch } from '../form/query-search';
import { parseNumber } from './vin';
import { CYR_NAME, REG_NO } from './custom';

export const PLATE_RE = /^\d{4}[А-ЯӨҮЁ]{3}$/;

export const formSchema = (values: any) =>
  Yup.object().shape({
    plateNumber: Yup.string()
      .transform((v) => (v ? v.toUpperCase().replace(/\s+/g, '') : v))
      .matches(PLATE_RE, 'Формат: эхний 4 нь тоо, сүүлийн 3 нь крилл том үсэг (ж: 5929УНС)')
      .required('Заавал оруулах'),
    price: Yup.number().min(0, '0 -с их байх шаардаглгатай').required('Заавал оруулах'),
    modelId: Yup.string().required('Заавал оруулах'),
    brandId: Yup.string().required('Заавал оруулах'),
    fullName: Yup.string()
      .trim()
      .matches(CYR_NAME, 'Зөвхөн крилл үсэг (зай, зураас) ашиглана уу')
      .required('Овог нэр заавал оруулах'),
    registerNo: Yup.string()
      .transform((v) => (v ? v.toUpperCase().replace(/\s/g, '') : v))
      .matches(REG_NO, 'Формат: 2 крилл үсэг + 8 тоо (ж: УБ12345678)')
      .required('Регистрийн дугаар заавал оруулах'),
  });

type FormDataType = {
  plateNumber?: string;
  valuateType: string;
  price?: number;
  modelId?: string;
  optionId?: string;
  fullName?: string;
  registerNo?: string;
  brandId?: string;
};

type Props = {
  setAction: React.Dispatch<
    React.SetStateAction<{
      loading: boolean;
      payload: undefined;
      found?: 'ADDITIONAL_DATA' | 'IS_ADDITIONAL_DATA' | boolean;
    }>
  >;
};

// ZVW305122690

const ValuationRegisterNoForm = memo(({ setAction }: Props) => {
  const [general, setGeneral] = useState<Dictionaries>();
  const [messageApi, contextHolder] = message.useMessage();
  const loadData = useCallback(async () => {
    const res = await GeneralApi.init();
    setGeneral(res);
  }, []);
  const [loading, setLoading] = useState(false);

  const initialValues: FormDataType = {
    valuateType: 'PLATE_NUMBER',
    plateNumber: undefined,
    price: undefined,
    modelId: undefined,
    optionId: undefined,
    fullName: undefined,
    registerNo: undefined,
    brandId: undefined,
    //   valuateType: 'PLATE_NUMBER',
    // plateNumber: '8449УБЯ',
    // price: 20000000,
    // modelId: undefined,
    // optionId: undefined,
    // fullName: undefined,
    // registerNo: undefined,
  };

  const onSubmit = useCallback(
    async (values: FormDataType) => {
      setAction({
        loading: true,
        payload: undefined,
      });

      try {
        setLoading(true);
        console.log('on submit :', values);
        const res = await ValuationApi.valuate(values);

        setAction({
          loading: false,
          payload: res,
          found: 'IS_ADDITIONAL_DATA',
        });
        setLoading(false);
      } catch (err: any) {
        messageApi.error(err?.message);
        setLoading(false);
        setAction({
          loading: false,
          payload: undefined,
          found: 'IS_ADDITIONAL_DATA',
        });
      }
    },
    [messageApi, setAction]
  );

  const formatter: InputNumberProps<number>['formatter'] = (value) => {
    const [start, end] = `${value}`.split('.') || [];
    const v = `${start}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return `₮ ${end ? `${v}.${end}` : `${v}`}`;
  };

  const getOption = useCallback((value?: { code?: string; name: string; id: string }[] | any) => {
    if (!value) {
      return [];
    }

    return value.map((item: any) => ({
      label: item.name,
      value: item.code ?? item.id,
    }));
  }, []);

  React.useEffect(() => {
    loadData();
  }, [loadData]);

  return (
    <>
      {contextHolder}
      <Formik
        initialValues={initialValues}
        validationSchema={formSchema}
        onSubmit={(values: FormDataType, actions: FormikHelpers<FormDataType>) => onSubmit(values)}
      >
        {({ values, setFieldValue, handleSubmit, errors, touched }) => {
          return (
            <Container>
              <Form layout="vertical" className="form" onFinish={handleSubmit}>
                <Row gutter={16}>
                  <div className="w-[400px] pl-[10px] pr-[10px]">
                    <Row gutter={16}>
                      <Col span={12}>
                        <Form.Item
                          label="Овог, нэр"
                          validateStatus={errors.fullName && touched.fullName ? 'error' : ''}
                          help={errors.fullName && touched.fullName ? errors.fullName : ''}
                        >
                          <Input
                            name="fullName"
                            status={errors.fullName && touched.fullName ? 'error' : ''}
                            value={values.fullName}
                            onChange={(e) => setFieldValue('fullName', e.target.value)}
                            placeholder="Зээл хүсэгчийн овог, нэр"
                          />
                        </Form.Item>
                      </Col>
                      <Col span={12}>
                        <Form.Item
                          label="Регистрийн дугаар"
                          validateStatus={errors.registerNo && touched.registerNo ? 'error' : ''}
                          help={errors.registerNo && touched.registerNo ? errors.registerNo : ''}
                        >
                          <Input
                            name="registerNo"
                            value={(values as any).registerNo}
                            onChange={(e) => setFieldValue('registerNo', e.target.value)}
                            placeholder="Регистрийн дугаар"
                          />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Form.Item
                      label="Брэнд"
                      validateStatus={errors.brandId && touched.brandId ? 'error' : ''}
                      help={errors.brandId && touched.brandId ? errors.brandId : ''}
                    >
                      <QuerySearch
                        value={values.brandId || undefined}
                        onChange={(e) => setFieldValue('brandId', e)}
                        placeholder="Брэнд"
                        showSearch
                        loadData={BrandApi.select}
                      />
                    </Form.Item>
                    <Form.Item
                      label="Загвар"
                      validateStatus={errors.modelId && touched.modelId ? 'error' : ''}
                      help={errors.modelId && touched.modelId ? errors.modelId : ''}
                    >
                      <QuerySearch
                        value={values.modelId!}
                        onChange={(e) => {
                          setFieldValue('modelId', e);
                        }}
                        placeholder="Загвар сонгох"
                        showSearch
                        payload={{ carBrandId: values.brandId }}
                        loadData={ModelApi.select}
                      />
                    </Form.Item>
                    <Form.Item
                      label="Тоноглол"
                      layout="vertical"
                      validateStatus={errors.optionId && touched.optionId ? 'error' : ''}
                      help={errors.optionId && touched.optionId ? errors.optionId : ('' as any)}
                    >
                      <QuerySearch
                        value={values.optionId!}
                        onChange={(e) => setFieldValue('optionId', e)}
                        placeholder="Тоноглол"
                        showSearch
                        loadData={OptionApi.select(values.modelId!) as any}
                      />
                    </Form.Item>
                    <Form.Item
                      label="Улсын дугаар"
                      validateStatus={errors.plateNumber && touched.plateNumber ? 'error' : ''}
                      help={errors.plateNumber && touched.plateNumber ? errors.plateNumber : ''}
                    >
                      <Input
                        name="plateNumber"
                        status={errors.plateNumber && touched.plateNumber ? 'error' : ''}
                        value={values.plateNumber}
                        onChange={(e) => setFieldValue('plateNumber', e.target.value)}
                        placeholder="Улсын дугаар"
                      />
                    </Form.Item>

                    <Form.Item
                      label="Үнэ"
                      validateStatus={errors.price && touched.price ? 'error' : ''}
                      help={errors.price && touched.price ? errors.price : ''}
                    >
                      <InputNumber
                        name="price"
                        status={errors.price && touched.price ? 'error' : ''}
                        value={values.price}
                        onChange={(e) => setFieldValue('price', e)}
                        placeholder="Үнэ"
                        formatter={formatter}
                        className="w-full"
                        parser={parseNumber}
                      />
                    </Form.Item>
                  </div>
                </Row>
                <Button
                  className="primary-btn"
                  type="primary"
                  onClick={() => handleSubmit()}
                  loading={loading}
                >
                  Үнэлгээ хийх
                </Button>
              </Form>
            </Container>
          );
        }}
      </Formik>
    </>
  );
});

const Container = styled.div`
  border: solid 1px #ffefee;
  border-radius: 8px;
  padding: 16px;
  width: '100%';

  .form {
    max-width: 400px;
  }
`;

ValuationRegisterNoForm.displayName = 'ValuationRegisterNoForm';

export { ValuationRegisterNoForm };
